import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * La decision sobre una solicitud, en la campanita.
 *
 * EXISTE PORQUE EL DRIVER `alert` NO ES OPCIONAL. `AlertNotificationDriver::send()` crea la
 * fila en `notifications` para todos los destinatarios sin mirar preferencias; si el tipo no
 * tiene componente, `NotificationList` lo descarta con un `if (!NotificationComponent) return
 * null` — la notificacion no se ve pero SI cuenta en el contador de no leidas. El resultado
 * seria una campanita con un numero que no se puede bajar.
 *
 * El texto sale de `content()` del propio aviso (`{status: ...}`) y no del sujeto: el listado
 * pinta muchas notificaciones de golpe y consultar la solicitud de cada una seria una peticion
 * por fila. El estado ademas no cambia despues de decidirse, asi que la copia no envejece.
 */
export default class GroupRequestNotification extends Notification {
  icon() {
    if (this.status() === 'approved') return 'fas fa-check-circle';
    if (this.status() === 'observed') return 'fas fa-question-circle';

    return 'fas fa-inbox';
  }

  href() {
    // Siempre a la pagina de la solicitud: ella ya decide que estado mostrar (M4c si entro,
    // «no aprobada» con opcion de reintentar si no). Un enlace directo a la categoria fallaria
    // para el rechazo y para el caso en que el permiso `tagN.viewForum` no este puesto.
    return app.route('umbral-comunidad.solicitud');
  }

  content() {
    const status = this.status();
    const key = status === 'approved' ? 'request_approved' : status === 'observed' ? 'request_observed' : 'request_rejected';

    return app.translator.trans('umbral-comunidad.forum.notifications.' + key);
  }

  excerpt() {
    return null;
  }

  status(): string {
    const content: any = this.attrs.notification.content() || {};

    return content.status || 'rejected';
  }
}
